import type { WrpfRecordCategory } from "../handoff/types";
import { highestRecordCategory } from "./recordCategories";

export type RecordMarkingMode = "manual" | "automatic";

type TypedRecordMarkingInput = {
  mode: RecordMarkingMode;
  override: WrpfRecordCategory | false | undefined;
  categoryWhenResolved: WrpfRecordCategory | undefined;
  suggestionCategories: ReadonlyArray<WrpfRecordCategory>;
};

export const resolveRecordCategory = ({
  mode,
  override,
  categoryWhenResolved,
  suggestionCategories,
}: TypedRecordMarkingInput): WrpfRecordCategory | undefined => {
  if (override !== undefined) return override === false ? undefined : override;
  if (categoryWhenResolved !== undefined) return categoryWhenResolved;
  return mode === "automatic" ? highestRecordCategory(suggestionCategories) : undefined;
};

type RecordMarkingInput = {
  mode: RecordMarkingMode;
  override: boolean | undefined;
  wasMarkedWhenResolved: boolean;
  hasSuggestions: boolean;
};

export const isRecordAttemptMarked = ({
  mode,
  override,
  wasMarkedWhenResolved,
  hasSuggestions,
}: RecordMarkingInput): boolean => {
  if (override !== undefined) return override;
  if (wasMarkedWhenResolved) return true;
  return mode === "automatic" && hasSuggestions;
};
